var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgRewardCenter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 233,
    height: 233,
    viewBox: "0 0 233 233",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9a440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d97b40"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_2049",
    x: 0,
    y: 0,
    width: 233,
    height: 233,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.059
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8357",
    "data-name": "Group 8357",
    transform: "translate(4215 -12710)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4215, 12710)",
    filter: "url(#Rectangle_2049)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2049-2",
    "data-name": "Rectangle 2049",
    width: 203,
    height: 203,
    rx: 24,
    transform: "translate(18 12)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7172",
    "data-name": "Group 7172",
    transform: "translate(-4886 8813.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7170",
    "data-name": "Group 7170",
    transform: "translate(-1265.363 459.07) rotate(-19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2092",
    "data-name": "Rectangle 2092",
    transform: "translate(759 3991)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 18,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 59,
    height: 13,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_7152",
    "data-name": "Path 7152",
    transform: "translate(-21948.998 4139.293)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22740-148.963s10.855-22.064,19.055-9.331-19.055,9.915-19.055,9.915Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 22746.529296875 -152.1163940429688 C 22749.142578125 -152.1465454101562 22751.451171875 -152.3606262207031 22753.240234375 -152.7401275634766 C 22755.6953125 -153.2615814208984 22756.439453125 -153.9192352294922 22756.58984375 -154.0804748535156 C 22756.580078125 -154.2530517578125 22756.486328125 -154.8906555175781 22755.689453125 -156.1278228759766 C 22755.279296875 -156.7663116455078 22754.22265625 -158.2513580322266 22753.296875 -158.2513580322266 C 22752.283203125 -158.2513580322266 22750.126953125 -156.9542846679688 22747.380859375 -153.2987213134766 C 22747.083984375 -152.9038238525391 22746.80078125 -152.5073547363281 22746.529296875 -152.1163940429688 M 22745.884765625 -148.1127014160156 C 22742.5625 -148.1127014160156 22739.998046875 -148.3780517578125 22739.998046875 -148.3780517578125 L 22739.998046875 -148.9625396728516 C 22739.99609375 -148.9625244140625 22750.849609375 -171.0267944335938 22759.052734375 -158.2933349609375 C 22764.736328125 -149.4674530029297 22753.384765625 -148.1127014160156 22745.884765625 -148.1127014160156 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_7153",
    "data-name": "Path 7153",
    transform: "translate(-21969.59 4139.293)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22760.592-148.963s-10.855-22.064-19.055-9.331,19.055,9.915,19.055,9.915Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 22754.060546875 -152.1164245605469 C 22753.810546875 -152.4788055419922 22753.546875 -152.8466491699219 22753.271484375 -153.2144317626953 C 22750.498046875 -156.9322052001953 22748.31640625 -158.2513580322266 22747.29296875 -158.2513580322266 C 22746.3671875 -158.2513580322266 22745.310546875 -156.7663116455078 22744.900390625 -156.1278076171875 C 22744.103515625 -154.8907623291016 22744.009765625 -154.253173828125 22744 -154.0805206298828 C 22744.150390625 -153.9192810058594 22744.89453125 -153.2616577148438 22747.349609375 -152.7401885986328 C 22749.13671875 -152.3607482910156 22751.447265625 -152.1466369628906 22754.060546875 -152.1164245605469 M 22754.705078125 -148.1127014160156 C 22747.205078125 -148.1128845214844 22735.853515625 -149.4674530029297 22741.537109375 -158.2933349609375 C 22743.373046875 -161.1448822021484 22745.341796875 -162.2513732910156 22747.29296875 -162.2513732910156 C 22754.0546875 -162.2513732910156 22760.591796875 -148.9625396728516 22760.591796875 -148.9625396728516 L 22760.591796875 -148.3780517578125 C 22760.591796875 -148.3780517578125 22758.02734375 -148.1126251220703 22754.705078125 -148.1127014160156 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7156",
    "data-name": "Path 7156",
    d: "M22811-148.278v11.647",
    transform: "translate(-22020 4142.208)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7171",
    "data-name": "Group 7171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2093",
    "data-name": "Rectangle 2093",
    transform: "translate(764 4004)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 37,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 49,
    height: 32,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7155",
    "data-name": "Path 7155",
    d: "M22811-148.278v33.994",
    transform: "translate(-22020 4153.854)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardCenter);
export default __webpack_public_path__ + "static/media/reward-center.27949d0104c336b618753dd1ae109ed1.svg";
export { ForwardRef as ReactComponent };